module.exports = __webpack_public_path__ + "static/gsc-logo-fr-888c06b8ea2c9980a9e0d03c9d1072ec.png";